import { render, staticRenderFns } from "./InputFiltri.vue?vue&type=template&id=4c5335d1&scoped=true&"
import script from "./InputFiltri.vue?vue&type=script&lang=js&"
export * from "./InputFiltri.vue?vue&type=script&lang=js&"
import style0 from "./InputFiltri.vue?vue&type=style&index=0&id=4c5335d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5335d1",
  null
  
)

export default component.exports